import * as Flags from "country-flag-icons/react/3x2"
import type { ComponentType, SVGProps } from "react"

/** Cùng alias với `countryFlagEmoji.ts` — API cũ đôi khi trả "uk" thay vì mã ISO chuẩn "gb". */
const CODE_ALIASES: Record<string, string> = {
  uk: "gb",
}

type FlagIconComponent = ComponentType<SVGProps<SVGSVGElement> & { title?: string }>

/**
 * SVG cờ quốc gia (tỉ lệ 3:2) từ `country-flag-icons` — render inline, không tốn request mạng như
 * ảnh flagcdn (khác `CountryFlag`/`getCountryFlagImageUrl`, vẫn giữ nguyên cho các icon tròn nhỏ dùng
 * flagcdn hiện có, không đổi). Trả `undefined` nếu mã không khớp component nào.
 */
export const getCountryFlagIconComponent = (countryCode?: string | null): FlagIconComponent | undefined => {
  if (!countryCode) return undefined
  const normalized = (CODE_ALIASES[countryCode.toLowerCase()] ?? countryCode).toUpperCase()
  return (Flags as Record<string, FlagIconComponent | undefined>)[normalized]
}
